import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const JOB_CATEGORY = 'job-category';

export const useCategoryIdFromSlug = (
  pathname: string,
  queryCategoryId?: string
) => {
  const [response, setResponse] = useState('');

  const segments = useMemo(() => pathname.split('/').splice(1), [pathname]);
  const slug = useMemo(
    () => segments.slice(1).join('/').replace(/\/+$/, ''),
    [segments]
  );

  useEffect(() => {
    if (queryCategoryId) {
      setResponse(queryCategoryId);
    } else if (segments[0] === JOB_CATEGORY && slug) {
      axios
        .get(`/api/jobCategories/getId/${slug}`)
        .then((response) => {
          setResponse(response.data.data);
        })
        .catch((error) => {
          console.error(error);
          setResponse('');
        });
    }
  }, [queryCategoryId, segments, slug]);

  return response;
};
